module.exports = __webpack_public_path__ + "static/media/world.8b944096.svg";